import React, { useEffect, useRef, useState } from 'react';
import inViewUtility from '@montana/helpers/in-view.helper';

interface IInViewProps {
    children: ({ inView, ref }: IInViewChildren) => JSX.Element;
    singleFire?: boolean;
    offsetMarginPx?: number;
    threshold?: number | number[];
}

interface IInViewChildren {
    inView: boolean;
    ref: (ref: HTMLElement | null) => void;
}


export const InView: React.FC<IInViewProps> = React.memo((props: IInViewProps): JSX.Element => {

    const {
        children,
        singleFire,
        offsetMarginPx,
        threshold,
    } = props;

    const elementReference = useRef<HTMLElement | null>(null);
    const [inView, setInView] = useState(false);

    const setElement = (element: HTMLElement | null): void => {
        elementReference.current = element;
    };

    const unRegisterElement = (): void => inViewUtility.unobserve('inView', elementReference.current as Element);

    const onElementChange = (entry: IntersectionObserverEntry): void => {
        if (elementReference.current) {
            setInView(entry.isIntersecting);

            if (singleFire && entry.isIntersecting) {
                unRegisterElement();
            }
        }
    };

    useEffect((): void | (() => void) => {

        if (elementReference.current) {
            inViewUtility.observe(
                'inView',
                elementReference.current,
                onElementChange,
                {
                    rootMargin: `${offsetMarginPx || 0}px`,
                    threshold,
                },
            );

            return unRegisterElement;
        }

        return undefined;

    }, [elementReference.current]);


    return children({ inView, ref: setElement });

});

